import { ClbIcon } from '@celebration/design-system-react'
import Header from 'components/header'
import intl from 'react-intl-universal'
import styled from 'styled-components'

const Container = styled.div`
  .forbidden-access-content {
    display: flex;
    height: 75vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .forbidden-access-message {
    margin-top: 0em;
  }
`

const ForbiddenAccess = () => (
  <Container className="forbidden-access-page">
    <Header title={intl.get('forbiddenAccess.header.title')} />

    <div className='forbidden-access-content'>
      <ClbIcon icon='Lock' size='lg' />
      <h1>{intl.get('forbiddenAccess.content.title')}</h1>
      <p className='forbidden-access-message'>{intl.get('forbiddenAccess.content.message')}</p>
    </div>
  </Container>
)

export default ForbiddenAccess
